export default __webpack_public_path__ + "22a527cce8bec708f887a66485d6cfb7.png";